import { FormControl } from '@angular/forms';

export enum ACControlName {
  RodoStatement = 'rodoStatement',
}

export interface ACFormGroup {
  [ACControlName.RodoStatement]: FormControl<boolean>;
}
